import * as CSV from "csv-string";

import { delay } from "utils/promise";

import { toast } from "react-toastify";

import * as ScoreAPI from "api/ScoreAPI";
import * as DeployAPI from "api/DeployAPI";

import * as setupReducer from "containers/Setup/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as deployReducer from "containers/Deploy/reducer";
import * as deploymentsReducer from "containers/Deployments/reducer";
import * as runReducer from "containers/Run/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as globalReducer from "containers/App/reducer";
import { AibleClientFactory } from "client/aible/factory";
import { isEnabled } from "utils/featureFlags";

const UPDATE_FIELD = "predict/UPDATE_FIELD";
const UPDATE_BUCKETS = "predict/UPDATE_BUCKETS";
const UPDATE_FIELD_OPTION = "predict/UPDATE_FIELD_OPTION";
const UPDATE_FIELD_PREDICT = "predict/UPDATE_FIELD_PREDICT";
const UPDATE_SCENARIO = "predict/UPDATE_SCENARIO";
const RESET_PREDICT = "predict/RESET_PREDICT";
const DELETE_SCENARIO = "predict/DELETE_SCENARIO";
const SET_PREDICT = "predict/SET_PREDICT";

const initialState = {};

export default function predictReducer(state = initialState, action) {
  switch (action.type) {
    case RESET_PREDICT:
      return initialState;
    case SET_PREDICT:
      return {
        ...state,
        ...action.data
      };
    case UPDATE_FIELD:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          [action.key]: action.data
        }
      };
    case UPDATE_FIELD_PREDICT:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          ["predictions"]: {
            ...state[action.id]["predictions"],
            [action.key]: action.data
          }
        }
      };
    case UPDATE_FIELD_OPTION:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          ["options"]: {
            ...state[action.id]["options"],
            [action.key]: action.data
          }
        }
      };
    case UPDATE_BUCKETS:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          ["buckets"]: {
            ...state[action.id]["buckets"],
            [action.key]: action.data
          }
        }
      };
    case UPDATE_SCENARIO:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          ["scenarios"]: {
            ...state[action.id]["scenarios"],
            [action.key]: action.data
          }
        }
      };
    case DELETE_SCENARIO:
      const newState = { ...state };
      delete newState[action.id]["scenarios"][action.key];
      return newState;
    default:
      return state;
  }
}

/* Selectors */
export function getGlobal(state) {
  return state.predict;
}

export function getColumnSelections(state, jobId) {
  return getGlobal(state)[jobId] ? getGlobal(state)[jobId].options : {};
}

export function getPredictions(state, jobId, modelId) {
  return getGlobal(state)[jobId + "_" + modelId] ? getGlobal(state)[jobId + "_" + modelId].predictions : undefined;
}

export function getMinMax(state, jobId) {
  return getGlobal(state)[jobId] ? getGlobal(state)[jobId].minMax : undefined;
}

export function getHoverValue(state, jobId) {
  return getGlobal(state)[jobId] ? getGlobal(state)[jobId].hoverValue : undefined;
}

export function getScenarios(state, jobId, showAll = false, projectId = undefined) {
  const selModel = runReducer.getCapModel(state, jobId, projectId) || {};
  const scenarios =
    getGlobal(state)[jobId] && getGlobal(state)[jobId].scenarios ? getGlobal(state)[jobId].scenarios : [];

  if (projectId !== undefined && false) {
    return showAll
      ? scenarios
      : scenarios
        ? Object.keys(scenarios)
            .filter(
              (s) =>
                scenarios[s].predictModels && scenarios[s].predictModels.filter((m) => m.id === selModel.id).length > 0
            )
            .map((s) => scenarios[s])
        : [];
  }

  return showAll
    ? scenarios
    : scenarios
      ? Object.keys(scenarios)
          .filter(
            (s) =>
              (scenarios[s].predictModels &&
                scenarios[s].predictModels.filter((m) => m.id === selModel.id).length > 0) ||
              true
          )
          .map((s) => scenarios[s])
      : [];
}

export function getScenarioIndex(state, jobId) {
  return getGlobal(state)[jobId] ? getGlobal(state)[jobId].scenarioIndex : undefined;
}

export function getColumnOptions(state, jobId) {
  const dataset = setupReducer.getDatasetFromSetup(state, jobId);
  const selections = getColumnSelections(state, jobId);

  const buckets = runReducer.getFeatureBuckets(state, jobId);

  return dataset && dataset.fields
    ? Object.keys(dataset.fields)
        .filter((f) => f !== dataset.outcome)
        .map((f) => ({
          label: f,
          type: dataset.fields[f].type,
          options:
            dataset.fields[f].data &&
            dataset.fields[f].data.map((d) => ({
              label: d.value,
              value: d.value
            })),
          selection: selections ? selections[f] : undefined
        }))
    : undefined;
}

export function getChooseOptions(state, jobId) {
  const colSelections = getColumnSelections(state, jobId);

  const selOptions = colSelections
    ? Object.keys(colSelections)
        .filter((c) => colSelections[c] !== "Blank-Aible")
        .map((c) => ({ field: c, value: colSelections[c] }))
    : undefined;

  let chooseOptions = [];

  for (const option of selOptions) {
    for (const tOption of options) {
      if (option.field === tOption.field) {
        if (option.value === tOption.value) {
          chooseOptions.push(tOption);
        } else if (tOption.min && option.value >= tOption.min && option.value <= tOption.max) {
          chooseOptions.push(tOption);
        }
      }
    }
  }

  return chooseOptions;
}

export function getPrediction(state, jobId, scenario = undefined) {
  const row = scenario ? scenario.row : buildRowForSelect(state, jobId);
  const minMax = scenario ? scenario.minMax : getMinMax(state, jobId);
  const predictModels = scenario ? scenario.predictModels : runReducer.getPredictModels(state, jobId);

  let retRow = [];

  row &&
    predictModels &&
    predictModels.forEach((m) => {
      row.forEach((r) =>
        getPredictions(state, jobId, m.id) && getPredictions(state, jobId, m.id)[r]
          ? retRow.push({
              ...getPredictions(state, jobId, m.id)[r],
              model: m.id
            })
          : undefined
      );
    });

  return retRow === undefined
    ? undefined
    : retRow.length === 0
      ? undefined
      : retRow.indexOf(undefined) !== -1
        ? undefined
        : retRow.sort((a, b) =>
            minMax && minMax.isMin === true
              ? (Number(b.prediction) - Number(a.prediction)) * -100 + Number(a.probability) - Number(b.probability)
              : (Number(b.prediction) - Number(a.prediction)) * 100 + Number(b.probability) - Number(a.probability)
          );
}

export function getFieldRange(field) {
  const retValues = {
    label: field,
    value: field
  };
  if (field && field.includes(" to ")) {
    const parsedField = field
      .replace("more than ", "")
      .replace(">", "")
      .split(" to ")
      .map((num) => {
        switch (num.trim()) {
          case "inf":
            return Infinity;
          case "-inf":
            return -Infinity;
          default:
            return Number(num);
        }
      });
    const [min, max] = parsedField;
    if (!isNaN(min) && !isNaN(max)) {
      retValues.min = min;
      retValues.max = max;
      retValues.value = (retValues.min + retValues.max) / 2;
      if (!isFinite(retValues.min) && !isFinite(retValues.max)) {
        retValues.value = 1;
      } else if (!isFinite(retValues.min) && isFinite(retValues.max)) {
        retValues.value = retValues.max - 2 * Math.max(1, Math.abs(retValues.max));
      } else if (!isFinite(retValues.max) && isFinite(retValues.min)) {
        retValues.value = retValues.min + 2 * Math.max(1, Math.abs(retValues.min));
      }
    }
  }
  return retValues;
}

export const getMinMaxFromString = (bar, label) => {
  if (label && label.includes(" to ")) {
    const retRange = getFieldRange(label);
    retRange.field = bar.label;
    retRange.label = bar.label + ": " + retRange.label;
    return retRange;
  } else {
    return {
      label: bar.label + ": " + replaceName(label),
      value: label,
      field: bar.label
    };
  }
};

export const replaceName = (name) => {
  return name === "Blank-Aible" ? "I Don't Know" : name === "Rare-Value-Aible" ? "Rare-Value" : name;
};

function formatField(field, changedSelections) {
  const matches = changedSelections?.filter((s) => s.column === field.label);

  if (matches?.length > 0) {
    const selection = matches[0].selection;

    if (selection === "Blank-Aible" || selection === "{Missing}") {
      return "";
    } else if (field.label.indexOf("Date") !== -1 || field.label.indexOf("SystemMod") !== -1) {
      return "";
    } else if (field.type === "number" && typeof selection == "string") {
      return selection;
    } else if (field.type === "categorical") {
      return `"${selection}"`;
    } else {
      return selection;
    }
  } else {
    return "";
  }

  /*
    else if (field.type === "categorical") {
    if (!(field.data && field.data[0])) {
      return undefined;
    } else {
      const retVal = field.data[0].value;
      if (retVal.includes(",")) {
        return `"${retVal}"`;
      } else {
        return retVal;
      }
    }
  } else {
    return field.min;
  }
  */
}

export function buildRow(state, jobId) {
  const dataset = setupReducer.getDatasetFromSetup(state, jobId);
  if (dataset === undefined) {
    return undefined;
  }
  const selections = getColumnSelections(state, jobId);
  const minMax = getMinMax(state, jobId);
  const buckets = runReducer.getFeatureBuckets(state, jobId);

  const changedSelections =
    selections &&
    Object.keys(selections)
      .filter((s) => selections[s] !== undefined)
      .map((s) => ({ column: s, selection: selections[s] }));

  const formatBase = (field) => formatField(field, changedSelections);

  const row =
    minMax && minMax.field !== undefined
      ? Object.keys(buckets[minMax.field])
          .map((mKey) =>
            Object.keys(dataset.fields)
              .map((f) => dataset.fields[f])
              .map((f) =>
                minMax.field === f.label
                  ? // check if the value key exists and use that if we want to remove Infinity from being sent
                    buckets[minMax.field][mKey].first && buckets[minMax.field][mKey].first === "{Missing}"
                    ? ""
                    : buckets[minMax.field][mKey].first
                      ? buckets[minMax.field][mKey].first
                      : isNaN(buckets[minMax.field][mKey].min) || isNaN(buckets[minMax.field][mKey].max)
                        ? buckets[minMax.field][mKey].value
                        : (buckets[minMax.field][mKey].min + buckets[minMax.field][mKey].max) / 2
                  : formatBase(f)
              )
              .join(",")
          )
          .join("\n")
      : changedSelections && [
          Object.keys(dataset.fields)
            .map((f) => formatBase(dataset.fields[f]))
            .join(",")
        ];

  return row;
}

export function buildRowForSelect(state, jobId) {
  const dataset = setupReducer.getDatasetFromSetup(state, jobId);
  const selections = getColumnSelections(state, jobId);
  const minMax = getMinMax(state, jobId);
  const buckets = runReducer.getFeatureBuckets(state, jobId);

  if (dataset === undefined) {
    return undefined;
  }

  const changedSelections =
    selections &&
    Object.keys(selections)
      .filter((s) => selections[s] !== undefined)
      .map((s) => ({ column: s, selection: selections[s] }));

  const formatBase = (field) => formatField(field, changedSelections);

  const row =
    minMax && minMax.field !== undefined
      ? changedSelections && dataset.fields[minMax.field] && dataset.fields[minMax.field].data
        ? dataset.fields[minMax.field].data.map((minMaxVal) =>
            Object.keys(dataset.fields)
              .map((f) => dataset.fields[f])
              .map((f) => (minMax.field === f.label ? minMaxVal.value : formatBase(f)))
              .join(",")
          )
        : Object.keys(buckets[minMax.field] || {}).map((mKey) =>
            Object.keys(dataset.fields)
              .map((f) => dataset.fields[f])
              .map((f) =>
                minMax.field === f.label
                  ? (buckets[minMax.field][mKey].min + buckets[minMax.field][mKey].max) / 2
                  : formatBase(f)
              )
              .join(",")
          )
      : changedSelections && [
          Object.keys(dataset.fields)
            .map((f) => formatBase(dataset.fields[f]))
            .join(",")
        ];

  return row;
}

export function buildHeader(state, jobId) {
  const dataset = setupReducer.getDatasetFromSetup(state, jobId);

  const row =
    dataset &&
    dataset.fields &&
    Object.keys(dataset.fields)
      .map((f) => dataset.fields[f])
      .map((f) => `"${f.label}"`)
      .join(",") + "\n";

  return row;
}

/* Actions */
export function updateOptions(jobId, options) {
  return { type: UPDATE_FIELD, id: jobId, data: options, key: "options" };
}

export function updateMinMaxForce(jobId, minMax) {
  return (dispatch, getState) => {
    return dispatch({
      type: UPDATE_FIELD,
      id: jobId,
      data: minMax,
      key: "minMax"
    });
  };
}

export function resetMinMax(jobId) {
  return (dispatch, getState) => {
    const minMax = getMinMax(getState(), jobId);

    dispatch(updateFieldOption(jobId, minMax && minMax.field, "Blank-Aible"));

    return dispatch({
      type: UPDATE_FIELD,
      id: jobId,
      data: undefined,
      key: "minMax"
    });
  };
}

export function updateMinMax(jobId, field, isMin) {
  return (dispatch, getState) => {
    const minMax = getMinMax(getState(), jobId);

    if (minMax && minMax.field && field && minMax.field !== field) {
      dispatch(updateFieldOption(jobId, minMax.field, "Blank-Aible"));
    }

    return dispatch({
      type: UPDATE_FIELD,
      id: jobId,
      data: { field: field, isMin: isMin },
      key: "minMax"
    });
  };
}

export function updatePredictions(jobId, modelId, predictions) {
  return {
    type: UPDATE_FIELD,
    id: jobId + "_" + modelId,
    data: predictions,
    key: "predictions"
  };
}

export function updateFieldPredict(jobId, key, prediction) {
  return {
    type: UPDATE_FIELD_PREDICT,
    id: jobId,
    key: key,
    data: prediction
  };
}

export function updateScenario(jobId, key, scenario) {
  return {
    type: UPDATE_SCENARIO,
    id: jobId,
    key: key,
    data: scenario
  };
}

export function updateScenarioIndex(jobId, scenarioIndex) {
  return (dispatch, getState) => {
    const scenarios = getScenarios(getState(), jobId);

    const scenario = scenarios && scenarios[scenarioIndex] ? scenarios[scenarioIndex] : undefined;

    if (scenario && scenario.conversionGain) {
      dispatch(setupReducer.updateConversionGain(jobId, scenario.conversionGain));
    }

    if (scenario && scenario.conversionCost) {
      dispatch(setupReducer.updateConversionCost(jobId, scenario.conversionCost));
    }

    return dispatch({
      type: UPDATE_FIELD,
      id: jobId,
      key: "scenarioIndex",
      data: scenarioIndex
    });
  };
}

export function updateHoverValue(jobId, hoverValue) {
  return {
    type: UPDATE_FIELD,
    id: jobId,
    key: "hoverValue",
    data: hoverValue
  };
}

export function deleteScenario(jobId, scenarioIndex) {
  return {
    type: DELETE_SCENARIO,
    id: jobId,
    key: scenarioIndex
  };
}

export function resetPredict() {
  return {
    type: RESET_PREDICT
  };
}

export function setPredict(data) {
  return {
    type: SET_PREDICT,
    data: data
  };
}

export function updateFieldOption(jobId, field, option) {
  return (dispatch, getState) => {
    const dataset = setupReducer.getDatasetFromSetup(getState(), jobId);

    if (option === "@_@Scenario@_@") {
      dispatch(updateMinMax(jobId, field, false));
    } else if (option === "@_@Minimize@_@") {
      dispatch(updateMinMax(jobId, field, true));
    } else {
      const minMax = getMinMax(getState(), jobId);

      if (minMax && minMax.field === field) {
        dispatch(updateMinMax(jobId, undefined, undefined));
      }
    }

    dispatch(updateScenarioIndex(jobId, "new"));

    return dispatch({
      type: UPDATE_FIELD_OPTION,
      id: jobId,
      key: field,
      data: option
    });
  };
}

export function chooseScenario(jobId, scenario) {
  return (dispatch, getState) => {
    dispatch(updateMinMaxForce(jobId, scenario.minMax));
    dispatch(runReducer.updatePredictModels(jobId, scenario.predictModels));
    dispatch(updateOptions(jobId, scenario.colSelections));
    return dispatch(updateScenarioIndex(jobId, scenario.id));
  };
}

function getMinMaxBuckets(label) {
  if (label && label.indexOf(",") !== -1) {
    const vals = label.split(",");

    const min = vals[0].replace("(", "").replace("[", "");
    const max = vals[1].replace(")", "").replace("]", "");

    return {
      label: Number(min).toFixed(2) + " to " + Number(max).toFixed(2),
      value: (Number(min) + Number(max)) / 2,
      min: min,
      max: max
    };
  } else {
    return {
      label: this.replaceName(label),
      value: this.replaceName(label)
    };
  }
}

export function updateFromMessage(message) {
  return (dispatch, getState) => {
    const id = globalReducer.getCurrentRunId(getState());

    const colSelections = getColumnSelections(getState(), id);
    const parsedMessage = JSON.parse(message);

    const retOptions = {};

    for (const option of Object.keys(colSelections)) {
      retOptions[option] = "Blank-Aible";
    }

    Object.keys(parsedMessage)
      .filter((c) => colSelections[c])
      .forEach((c) => {
        retOptions[c] = parsedMessage[c];
      });

    dispatch(updateScenarioIndex(id, "new"));

    dispatch({
      type: UPDATE_FIELD,
      data: retOptions,
      id: id,
      key: "options"
    });

    return dispatch(handlePredict(id));
  };
}

export function updateFieldOptions(id, options) {
  return (dispatch, getState) => {
    const colSelections = getColumnSelections(getState(), id);

    const retOptions = {};

    if (colSelections) {
      for (const option of Object.keys(colSelections)) {
        retOptions[option] = colSelections[option] === "@_@Scenario@_@" ? colSelections[option] : "Blank-Aible";
      }
    }

    const minMax = getMinMax(getState(), id);

    for (const option of options) {
      retOptions[option.field] = option.fieldValue !== undefined ? option.fieldValue : option.value;

      if (minMax && minMax.field === option.field) {
        dispatch(updateMinMax(id, undefined, undefined));
      }
    }

    dispatch(updateScenarioIndex(id, "new"));

    return dispatch({
      type: UPDATE_FIELD,
      data: retOptions,
      id: id,
      key: "options"
    });
  };
}

export function init(jobId) {
  return (dispatch, getState) => {
    const dataset = setupReducer.getDatasetFromSetup(getState(), jobId);
    const features = runReducer.getFeatureOptions(getState(), jobId);
    const buckets = runReducer.getFeatureBuckets(getState(), jobId);

    dispatch(globalReducer.updateCurrentRunId(jobId));

    let options = {};

    if (buckets) {
      Object.keys(buckets).forEach((f) => {
        let retOption = "Blank-Aible";

        options[f] = retOption;
      });

      if (Object.keys(options).length > 0) {
        dispatch(updateOptions(jobId, options));
      }

      if (getScenarioIndex(getState(), jobId) === undefined) {
        dispatch(updateScenarioIndex(jobId, "new"));
      }
    } else {
      setTimeout(() => dispatch(init(jobId)), 1000);
    }

    //dispatch(handleGetPrediction(jobId, "aible-relative-impact", 509));
  };
}

export function predictAll(id, projectId) {
  return (dispatch, getState) => {
    const sIndex = getScenarioIndex(getState(), id);

    return dispatch(handlePredict(id, projectId, sIndex, undefined, true));
  };
}

export function handlePredict(id, projectId = undefined, sIndex = undefined, model = undefined, predictAll = false) {
  return (dispatch, getState) => {
    if (projectId === undefined) {
      projectId = projectReducer.getProjectIdFromRunId(getState(), id);
    }

    let selModel = model || runReducer.getCapModel(getState(), id, projectId);

    if (selModel === undefined) {
      const frontier = runReducer.getFrontier(getState(), id);

      if (frontier === undefined || Object.keys(frontier).length == 0) {
        dispatch(runReducer.saveFrontier(id));
        selModel = model || runReducer.getCapModel(getState(), id, projectId);
      }
    }

    const colSelections = getColumnSelections(getState(), id);
    const minMax = getMinMax(getState(), id);
    const scenarios = getScenarios(getState(), id, true);

    const chosenScenario =
      sIndex !== undefined
        ? Object.keys(scenarios).filter((s) => scenarios[s].id === sIndex).length > 0
          ? Object.keys(scenarios).filter((s) => scenarios[s].id === sIndex)[0]
          : undefined
        : undefined;

    const cScenario = scenarios && chosenScenario && scenarios[chosenScenario] ? scenarios[chosenScenario] : undefined;

    const scenarioIds = scenarios && Object.keys(scenarios);

    const scenarioIndex =
      chosenScenario !== undefined
        ? Number(chosenScenario)
        : scenarioIds && scenarioIds.length
          ? Math.max(...scenarioIds, 0) + 1
          : 0;

    if (selModel === undefined) {
      toast("There was an error generating the prediction. Please try again later.", {
        type: toast.TYPE.ERROR,
        position: toast.POSITION.TOP_CENTER,
        autoClose: 7500
      });
      return;
    }

    if (cScenario !== undefined) {
      const pModels =
        predictAll === true ? getAllPredictModels(getState(), id, projectId) : [...cScenario.predictModels, selModel];

      dispatch(
        updateScenario(id, scenarioIndex, {
          colSelections: { ...colSelections },
          minMax: minMax,
          predictModels: pModels,
          id: scenarioIndex,
          isLoading: 1,
          predictions: [...cScenario.predictions]
        })
      );
    } else {
      const pModels = predictAll === true ? getAllPredictModels(getState(), id, projectId) : [selModel];

      dispatch(
        updateScenario(id, scenarioIndex, {
          colSelections: { ...colSelections },
          minMax: minMax,
          predictModels: pModels,
          id: scenarioIndex,
          isLoading: 1,
          predictions: []
        })
      );
    }

    dispatch(updateScenarioIndex(id, scenarioIndex));

    if (isEnabled("aible-next-api") || true) {
      dispatch(handleAPIPredict(id, scenarioIndex, projectId, model, predictAll));
      return;
    }

    dispatch(handlePredictDeploys(id, scenarioIndex, projectId));
    dispatch(helperPredict(id, scenarioIndex, projectId, model, predictAll));
  };
}

function handleAPIPredict(id, scenarioIndex, projectId, model, predictAll) {
  return (dispatch, getState) => {
    const selModel = model || runReducer.getCapModel(getState(), id, projectId);

    const allModels = predictAll ? getAllPredictModels(getState(), id, projectId) : [selModel.id];

    const run = runReducer.getJob(getState(), id);

    const clientFactory = AibleClientFactory.getInstance();

    const accountClient = clientFactory.getAccountClient();

    const rows = buildHeader(getState(), id) + buildRow(getState(), id);

    return accountClient.getCustomerClientFactory(run.accountId).then((factory) => {
      const projectClient = factory.getProjectClient();

      return Promise.all(
        allModels.map((model) =>
          projectClient
            .whatIf(projectId, id, model, rows)
            .then((response) => dispatch(updatePredict(id, model, response.predictions, scenarioIndex)))
        )
      );
    });
  };
}

function getPredictModels(state, id, projectId) {
  if (projectId) {
    return [runReducer.getCapModel(state, id, projectId)];
  } else {
    return [{ id: runReducer.getFeatureSelection(state, id, true) }];
  }
}

export function handlePredictDeploys(id, scenarioIndex, projectId = undefined) {
  return (dispatch, getState) => {
    const state = getState();
    const deployments = {};

    const deployment = deploymentsReducer.getProjectDeployment(getState(), projectId);

    deployments[projectId] = deployment;

    Object.keys(deployments).forEach((d) => {
      const deployment = deployments[d];

      if (deployment === undefined || !deployment.endpoint_url) {
        dispatch(deploymentsReducer.handleRestfulProjectDeploy(projectId));
      }
    });
  };
}

export function updateAllPredictions(id, projectId) {
  return (dispatch, getState) => {
    if (projectId === undefined) {
      projectId = projectReducer.getProjectIdFromRunId(getState(), id);
    }

    const scenarios = getScenarios(getState(), id, true);

    if (scenarios) {
      Object.keys(scenarios).forEach((s) => {
        dispatch(
          updateScenario(id, s, {
            ...scenarios[s],
            predictions: [],
            isLoading: 1
          })
        );

        dispatch(helperPredict(id, s, projectId));
      });
    }

    dispatch(projectReducer.updateIsNewFrontier(projectId, false));
  };
}

export function getAllPredictModels(state, id, projectId) {
  const frontier = runReducer.getFrontierList(state, id);

  let retFrontier = [];

  frontier &&
    frontier.forEach((m) => {
      if (retFrontier.indexOf(m.id) === -1) {
        retFrontier.push(m.id);
      }
    });

  return retFrontier;
}

export function helperPredict(id, scenarioIndex, projectId = undefined, model = undefined, predictAll = false) {
  return (dispatch, getState) => {
    const state = getState();
    const rows = buildHeader(state, id) + buildRow(state, id);
    const selModel = model || runReducer.getCapModel(state, id, projectId);
    const minMax = getMinMax(state, id);

    const scenarios = getScenarios(getState(), id, true);

    const deployments = {};

    const deployment = deploymentsReducer.getProjectDeployment(getState(), projectId);

    deployments[projectId] = deployment;

    let shouldPredict = true;

    Object.keys(deployments).forEach((d) => {
      const deployment = deployments[d];

      if (deployment === undefined || !deployment.endpoint_url) {
        shouldPredict = false;
      }
    });

    const allModels = predictAll ? getAllPredictModels(getState(), id, projectId) : [selModel.id];

    if (shouldPredict === true) {
      Object.keys(deployments).forEach((d) => {
        const deployment = deployments[d];

        if (deployment && deployment.endpoint_url) {
          dispatch(fetchPredictions(id, scenarioIndex, deployment, rows, undefined, undefined, undefined, allModels));
        }
      });
    } else {
      return setTimeout(() => dispatch(helperPredict(id, scenarioIndex, projectId, model, predictAll)), 5000);
    }
  };
}

export function fetchPredictions(
  id,
  scenarioIndex,
  deployment,
  rows,
  startTime,
  pollUrl,
  failCount = 0,
  allModels = undefined
) {
  return (dispatch, getState) => {
    if (startTime === undefined) {
      startTime = new Date();
    } else {
      const elapsedTime = new Date() - startTime;

      if (elapsedTime > 2 * 60 * 1000) {
        // two minutes
        const scenarios = getScenarios(getState(), id, true);

        dispatch(
          updateScenario(id, scenarioIndex, {
            ...scenarios[scenarioIndex],
            isLoading: scenarios[scenarioIndex].isLoading - 1
          })
        );

        return Promise.resolve();
      }
    }

    let promise;

    if (allModels) {
      allModels.forEach((m, i) =>
        setTimeout(() => {
          if (pollUrl !== undefined) {
            promise = DeployAPI.pollDeploy(pollUrl, deployment.endpoint_headers);
          } else {
            promise = DeployAPI.scoreDeploy(deployment.endpoint_url, rows, deployment.endpoint_headers, {
              model_name: m,
              job_id: id,
              format: "csv",
              apply_transformations: false
            });
          }

          let didReturn = false;

          return promise
            .then((response) => {
              didReturn = true;

              if (
                response.status == "COMPLETED" ||
                (response.predictions !== undefined && response.predictions.length > 0)
              ) {
                dispatch(updatePredict(id, m, response.predictions, scenarioIndex));
                return Promise.resolve();
              } else {
                return delay(3000).then(() =>
                  dispatch(
                    fetchPredictions(id, scenarioIndex, deployment, rows, startTime, response.url, undefined, [m])
                  )
                );
              }
            })
            .catch((e) => {
              console.log(e);

              //response codes of 400 and 500 are also stop conditions
              if (didReturn || failCount > 20 || e.status === 500 || e.status === 400) {
                dispatch(deleteScenario(id, scenarioIndex));
                dispatch(updateScenarioIndex(id, "new"));
                toast("There was an error generating the prediction. Please try again later.", {
                  type: toast.TYPE.ERROR,
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 7500
                });
                return Promise.reject(e);
              }

              return delay(3000).then(() =>
                dispatch(fetchPredictions(id, scenarioIndex, deployment, rows, startTime, pollUrl, failCount + 1, [m]))
              );
            });
        }, i * 10)
      );
    }
  };
}

export function updatePredict(id, modelId, responsePredictions, scenarioIndex) {
  return (dispatch, getState) => {
    const fileLines = responsePredictions.split("\n");
    const colSelections = getColumnSelections(getState(), id);
    const isContinuous = runReducer.getIsContinuous(getState(), id);

    let predictions = getPredictions(getState(), id, modelId) ? { ...getPredictions(getState(), id, modelId) } : {};

    const headers = buildHeader(getState(), id);
    const headerCols = headers.replace(/\n/g, "").split(",");
    const buckets = runReducer.getFeatureBuckets(getState(), id);

    let varOffset =
      modelId === "Aible-Bayes-CL-1" ||
      modelId === "Aible-Bayes-CL-2" ||
      modelId === "Aible-Bayes-RG-1" ||
      modelId === "Aible-Bayes-RG-2"
        ? 3
        : 7;

    const scenarios = getScenarios(getState(), id, true);

    const minMax = scenarios && scenarios[scenarioIndex] ? scenarios[scenarioIndex].minMax : {};

    let minMaxIndex = undefined;

    if (minMax && minMax.field) {
      minMaxIndex = headerCols.indexOf('"' + minMax.field + '"');
    }

    let nPredictions = scenarios[scenarioIndex] ? [...scenarios[scenarioIndex].predictions] : [];

    const parsedFile = CSV.parse(responsePredictions);

    let infoColIndex = -1;

    const parsedHeaders = parsedFile[0] ?? [];

    // Find the index of 'predict_score' for the offset
    // Note: all these columns should really be found and indexed programmatically
    if (parsedFile && parsedFile[0] && parsedFile[0].length) {
      let predictScoreIndex = parsedFile[0].indexOf("predict_score");
      if (predictScoreIndex >= 0) {
        varOffset = parsedFile[0].length - predictScoreIndex;
      }
      infoColIndex = parsedFile[0].indexOf("row_level_prediction_driver_json");
    }

    const driverColPairs = [];

    for (let i = 1; i < 6; i++) {
      const impactIndex = parsedHeaders.indexOf(`Impact ${i}`);
      const driverIndex = parsedHeaders.indexOf(`Driver ${i}`);

      if (driverIndex >= 0 && impactIndex >= 0) {
        driverColPairs.push([driverIndex, impactIndex]);
      } else {
        break;
      }
    }

    parsedFile
      .filter((line, i) => i > 0 && i < fileLines.length - 1)
      .forEach((vars) => {
        let row = "";

        vars
          .filter((v, i) => i < vars.length - (isContinuous ? varOffset : varOffset + 1))
          .forEach((v, i) => {
            const cSel = colSelections[headerCols[i]];

            let retV = v;

            if (cSel - 0.001 < v && cSel + 0.001 > v) {
              retV = cSel;
            }

            if (minMax && minMax.field === headerCols[i]) {
              const selBuckets = buckets[headerCols[i]] || {};

              Object.keys(selBuckets)
                .filter((k) => selBuckets[k].min !== undefined)
                .forEach((k) => {
                  if (selBuckets[k].min <= v && selBuckets[k].max >= v) {
                    retV = (selBuckets[k].min + selBuckets[k].max) / 2;
                  }
                });
            }

            row = row + retV + (i < vars.length - (isContinuous ? varOffset + 1 : varOffset + 2) ? "," : "");
          });

        predictions[row] = isContinuous
          ? {
              prediction: vars[vars.length - varOffset]
            }
          : {
              prediction: vars[vars.length - (varOffset + 1)],
              probability:
                vars[vars.length - (varOffset + 1)] === "0.0"
                  ? Number(vars[vars.length - varOffset]) * 100
                  : Number(vars[vars.length - varOffset]) * 100
            };

        let info = undefined;
        if (infoColIndex >= 0) {
          try {
            info = isContinuous ? JSON.parse(vars[infoColIndex]) : JSON.parse(vars[infoColIndex]);
          } catch (e) {
            console.log(e);
          }
        } else {
          info = { rowLevelDrivers: [] };

          for (let [driverIndex, impactIndex] of driverColPairs) {
            try {
              info.rowLevelDrivers.push({
                variable: vars[driverIndex],
                impact: parseFloat(vars[impactIndex])
              });
            } catch (e) {
              console.log(e);
            }
          }
        }

        if (minMaxIndex !== undefined && minMaxIndex !== -1) {
          predictions[row].field = minMax.field;
          predictions[row].value = vars[minMaxIndex];

          nPredictions.push({
            field: minMax.field,
            model: modelId,
            value: vars[minMaxIndex],
            prediction: isContinuous ? vars[vars.length - varOffset] : vars[vars.length - (varOffset + 1)],
            probability: isContinuous
              ? undefined
              : vars[vars.length - (varOffset + 1)] === "0.0"
                ? Number(vars[vars.length - varOffset]) * 100
                : Number(vars[vars.length - varOffset]) * 100,
            info: info
          });
        } else {
          nPredictions.push({
            model: modelId,
            prediction: isContinuous ? vars[vars.length - varOffset] : vars[vars.length - (varOffset + 1)],
            probability: isContinuous
              ? undefined
              : vars[vars.length - (varOffset + 1)] === "0.0"
                ? Number(vars[vars.length - varOffset]) * 100
                : Number(vars[vars.length - varOffset]) * 100,
            info: info
          });
        }
      });

    //dispatch(updatePredictions(id, modelId, predictions));

    dispatch(
      updateScenario(id, scenarioIndex, {
        ...scenarios[scenarioIndex],
        predictions: nPredictions,
        isLoading: scenarios[scenarioIndex].isLoading - 1
      })
    );

    dispatch(saveToStorage());
  };
}

export function handlePredictBad(id) {
  return (dispatch, getState) => {
    const selections = getColumnSelections(getState(), id);
    const dataset = setupReducer.getDatasetFromSetup(getState(), id);

    const changedSelections = Object.keys(selections)
      .filter((s) => selections[s] !== undefined && dataset.fields[s].type === "categorical")
      .map((s) => ({ column: s, selection: selections[s] }));

    let rows = [
      Object.keys(selections)
        .map((f) => f)
        .join(",") + "\n",
      Object.keys(selections)
        .map((f) => (selections[f] !== undefined ? selections[f] : " "))
        .join(",") + "\n"
    ];

    for (const selection of changedSelections) {
      rows.push(
        Object.keys(selections)
          .map((f) =>
            (selections[f] !== undefined && selection.column === f) || dataset.fields[f].type === "number"
              ? selections[f]
              : " "
          )
          .join(",") + "\n"
      );
    }

    const file = new File(rows, "predictfixme_" + id + ".csv", {
      type: "text/csv"
    });

    return ScoreAPI.uploadPrediction(id, "ada-boost-r", file).then((response) => {
      dispatch(handleGetPrediction(id, "ada-boost-r", response.id));
    });
  };
}

function handleGetPrediction(jobId, modelId, scoreId) {
  return (dispatch, getState) => {
    const score = deployReducer.getScore(getState(), jobId, modelId, scoreId);

    if (score === undefined || (score.status !== "DONE" && score.status !== "ERROR")) {
      dispatch(deployReducer.pollStatusOnce(scoreId));
      setTimeout(() => dispatch(handleGetPrediction(jobId, modelId, scoreId)), 5000);
    } else {
      if (score.status === "DONE") {
        ScoreAPI.getScoreFile(scoreId).then((response) => {
          response.data.then((csv) => {
            const fileLines = csv.split("\n");

            let predictions = {};

            fileLines
              .filter((line, i) => i > 0 && i < fileLines.length - 1)
              .forEach((line) => {
                let row = "";

                const vars = line.split(",");

                vars
                  .filter((v, i) => i < vars.length - 2)
                  .forEach((v, i) => (row = row + v + (i < vars.length - 3 ? "," : "")));

                predictions[row] = {
                  prediction: vars[vars.length - 2],
                  probability: vars[vars.length - 1]
                };
              });

            dispatch(updatePredictions(jobId, predictions));
          });
        });
      }
    }
  };
}

export function getSelectedScenario(state, jobId) {
  const scenarioIndex = getScenarioIndex(state, jobId);

  const scenarios = getScenarios(state, jobId);

  const retScenario =
    scenarioIndex !== undefined && scenarios !== undefined && scenarios.filter((s) => s.id === scenarioIndex).length > 0
      ? scenarios.filter((s) => s.id === scenarioIndex)[0]
      : undefined;

  return retScenario;
}

export function deleteCurrentScenario(jobId) {
  return (dispatch, getState) => {
    const scenarioIndex = getScenarioIndex(getState(), jobId);

    dispatch(deleteScenario(jobId, scenarioIndex));
    dispatch(updateScenarioIndex(jobId, "new"));
    dispatch(saveToStorage());
  };
}

export function updateScenarioConversionGain(id, conversionGain) {
  return (dispatch, getState) => {
    const scenario = getSelectedScenario(getState(), id);

    if (scenario) {
      dispatch(
        updateScenario(id, scenario.id, {
          ...scenario,
          conversionGain: conversionGain
        })
      );
    }

    return Promise.resolve();
  };
}

export function updateScenarioConversionCost(id, conversionCost) {
  return (dispatch, getState) => {
    const scenario = getSelectedScenario(getState(), id);

    if (scenario) {
      dispatch(
        updateScenario(id, scenario.id, {
          ...scenario,
          conversionCost: conversionCost
        })
      );
    }

    return Promise.resolve();
  };
}

export function updateScenarioConversionSaved(id, conversionSaved) {
  return (dispatch, getState) => {
    const scenario = getSelectedScenario(getState(), id);

    if (scenario) {
      dispatch(
        updateScenario(id, scenario.id, {
          ...scenario,
          conversionSaved: conversionSaved
        })
      );
    }

    return Promise.resolve();
  };
}

export function updateScenarioConversionMissed(id, conversionMissed) {
  return (dispatch, getState) => {
    const scenario = getSelectedScenario(getState(), id);

    if (scenario) {
      dispatch(
        updateScenario(id, scenario.id, {
          ...scenario,
          conversionMissed: conversionMissed
        })
      );
    }

    return Promise.resolve();
  };
}

export function initFromStorage() {
  return (dispatch, getState) => {
    const rawPredict = loginReducer.getItem(getState(), "aible_predict") || "e30=";
    let parsedPredict;
    try {
      parsedPredict = JSON.parse(rawPredict);
    } catch (e) {
      parsedPredict = JSON.parse(atob(rawPredict));
    }

    dispatch(setPredict(parsedPredict));
  };
}

export function saveToStorage() {
  return (dispatch, getState) => {
    const parsedPredict = getGlobal(getState());
    const rawPredict = JSON.stringify(parsedPredict);
    localStorage.setItem("aible_predict", rawPredict);
  };
}

export function deleteStorage() {
  return (dispatch, getState) => {
    dispatch(resetPredict());
    localStorage.removeItem("aible_predict");
  };
}
